import type { UploadedFile } from "@pharmupp/p3-front-commons"
import type { LocationType } from "../../Events/model"
import type {
  NewsCreatorTypeName,
  NewsRubricsName,
  NewsStatusesName,
} from "../../commons"
import type { NewsCategory } from "./ApiFormPostReferential"
import type { NewsCreatorRoles } from "./NewsCreatorRoles"

export type ApiDisplayNews = ApiNewsEvent | ApiNewsPost

export interface ApiNewsBase {
  id: number
  postType: PostType
  title: string
  description: string
  publicationDate: string
  creatorType: NewsCreatorTypeName
  creatorRole: NewsCreatorRoles
  image?: UploadedFile
  rubric: NewsRubricsName
  logo?: UploadedFile
  author: string
  flash: boolean
  views: number
  status: NewsStatusesName
  laboratoryId?: number
}

export type ApiNewsPost = ApiNewsBase & {
  postType: PostType.NEWS_POST
  category?: NewsCategory
}

export type ApiNewsEvent = ApiNewsBase & {
  postType: PostType.EVENT
  startDate: Date
  endDate: Date
  registrationDeadline: Date
  remainingSubscriptions?: number
  isRegistered: boolean
  canSubscribe: boolean
  canUnsubscribe: boolean
  cancelled: boolean
  cancellationReason?: string
} & (IrlFields | RemoteFields)

interface IrlFields {
  locationType: LocationType.IRL
  address: {
    line1: string
    line2?: string
    postalCode: string
    city: string
  }
}

interface RemoteFields {
  locationType: LocationType.REMOTE
  meetUrl: string
}

export enum PostType {
  NEWS_POST = "NEWS_POST",
  EVENT = "EVENT",
}
